export const SystemList = [
    {
        imageUrl: "/image/skills/google_analytics.png",
        altTag: "google analytics image",
        title: "Google Analytics"
    },
    {
        imageUrl: "/image/skills/magento.png",
        altTag: "magento image",
        title: "Magento 2"
    },
    {
        imageUrl: "/image/skills/sitecore.png",
        altTag: "sitcore image",
        title: "Sitecore"
    },
    {
        imageUrl: "/image/skills/optimisley.png",
        altTag: "optimisley image",
        title: "Optimisley"
    },
    {
        imageUrl: "/image/skills/squarespace.png",
        altTag: "squarespace image",
        title: "Squarespace"
    },
    {
        imageUrl: "/image/skills/wordpress.png",
        altTag: "wordpress image",
        title: "Wordpress"
    },
    {
        imageUrl: "/image/skills/shopify.png",
        altTag: "shopify image",
        title: "Shopify"
    },
    {
        imageUrl: "/image/skills/photoshop.png",
        altTag: "photoshop image",
        title: "Adobe Photoshop"
    },
    {
        imageUrl: "/image/skills/figma.png",
        altTag: "figma image",
        title: "Figma"
    },
    {
        imageUrl: "/image/skills/canva.png",
        altTag: "canva image",
        title: "Canva"
    },
    {
        imageUrl: "/image/skills/klaviyo.png",
        altTag: "klaviyo image",
        title: "Klaviyo"
    },
]